export default __webpack_public_path__ + "static/media/CN.ff857589.svg";